import { render } from "./StafetDonationTaendLysStepTwo.vue?vue&type=template&id=cc66a5e6"
import script from "./StafetDonationTaendLysStepTwo.vue?vue&type=script&lang=js"
export * from "./StafetDonationTaendLysStepTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__